export default __webpack_public_path__ + "static/media/Google-gray.368cc14b.svg";